import React from "react";
import { sendEventTracking } from "../../utils/GeneralUtils";
import { useMetaData } from "../../utils/useMetaData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// css
import Styles from "./DocumentationPage.module.scss";
import DocumentCoverService from "../../assets/img/documentation/document-cover-service-2025.webp";
import DocumentCoverSchool from "../../assets/img/documentation/document-cover-school.webp";
import DocumentCoverCasting from "../../assets/img/documentation/document-cover-casting.webp";
import ContactBtn from "../../assets/img/top-work/contact-btn-ylw.webp";
import Logo from "../../assets/img/logo.svg";
import Thankyou from "../../assets/img/documentation/thankyou.webp";
import SonicLink from "../../common/routing/SonicLink";

const DocumentationPage: React.FC = () => {
  useMetaData({
    title: "資料ダウンロード",
    description:
      "SELeCTに関する資料をダウンロードしていただけます。SELeCTは企業・会社と個人のeスポーツ事業をサポートします。eスポーツに関する様々な事業や企画・イベントについて、経験豊富なSELeCTのエージェントが徹底的にサポート。「これから始めたいけどどうすれば良いかわからない」「始めたけれど困っている」などあらゆる問題を解決します。",
    imgUrl: "",
  });

  return (
    <div className={Styles["doc__page"]}>
      <div className={Styles["doc__hero-image-area"]}>
        <div className={Styles["doc__hero-ttl-area"]}>
          <div className={Styles["doc__hero-ttlbox"]}>
            <img src={Logo} alt="" className={Styles["doc__hero-logo"]} />
            <div className={Styles["doc__hero-english"]}>DOCUMENTATION</div>
            資料ダウンロード
          </div>
        </div>
      </div>
      <div className={Styles["doc__container"]}>
        <div className={Styles["doc__ttl"]}>各種資料ダウンロード</div>
        <ul className={Styles["doc__list"]}>
          <li className={Styles["doc__list-item"]}>
            <div className={Styles["doc__document-coverbox"]}>
              <img
                src={DocumentCoverService}
                alt="SELeCTサービス資料"
                className={Styles["doc__document-cover"]}
              />
            </div>
            <div className={Styles["doc__document-ttl"]}>
              SELeCTサービス資料
            </div>
            <a
              href="https://www.dropbox.com/scl/fi/qz455xho5pbf352zdya5c/SELeCT.pdf?rlkey=wklm89eor8ddthbehshfg6ccf&dl=1"
              className={Styles["doc__dl-btn"]}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                sendEventTracking(
                  "click",
                  "DocumentationService",
                  "サービス資料DL"
                )
              }
            >
              ダウンロードする
              <FontAwesomeIcon icon={["fas", "external-link-alt"]} />
            </a>
            <div className={Styles["doc__thankyou"]}>
              <img src={Thankyou} alt="ありがとうございます！" />
            </div>
          </li>
          <li className={Styles["doc__list-item"]}>
            <div className={Styles["doc__document-coverbox"]}>
              <img
                src={DocumentCoverCasting}
                alt="キャスティング資料"
                className={Styles["doc__document-cover"]}
              />
            </div>
            <div className={Styles["doc__document-ttl"]}>
              キャスティング資料
            </div>
            <a
              href="https://www.dropbox.com/scl/fi/28dvwwh83dhzw8l4e7tif/SELeCT-e.pdf?rlkey=f0113ich57jk7lnkwv2x6ifr6&dl=1"
              className={Styles["doc__dl-btn"]}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                sendEventTracking(
                  "click",
                  "DocumentationCasting",
                  "キャスティング資料DL"
                )
              }
            >
              ダウンロードする
              <FontAwesomeIcon icon={["fas", "external-link-alt"]} />
            </a>
            <div className={Styles["doc__thankyou"]}>
              <img src={Thankyou} alt="ありがとうございます！" />
            </div>
          </li>
          <li className={Styles["doc__list-item"]}>
            <div className={Styles["doc__document-coverbox"]}>
              <img
                src={DocumentCoverSchool}
                alt="教育機関向け資料"
                className={Styles["doc__document-cover"]}
              />
            </div>
            <div className={Styles["doc__document-ttl"]}>教育機関向け資料</div>
            <a
              href="https://www.dropbox.com/scl/fi/8n6wxaytpccnvm7qm8kwf/e.pdf?rlkey=s34z0bowo39w5p8abt445y67q&dl=1"
              className={Styles["doc__dl-btn"]}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                sendEventTracking(
                  "click",
                  "DocumentationSchool",
                  "教育機関向け資料DL"
                )
              }
            >
              ダウンロードする
              <FontAwesomeIcon icon={["fas", "external-link-alt"]} />
            </a>
            <div className={Styles["doc__thankyou"]}>
              <img src={Thankyou} alt="ありがとうございます！" />
            </div>
          </li>
        </ul>
        <div className={Styles["doc__contact"]}>
          <SonicLink
            to="/contact"
            onClick={() =>
              sendEventTracking(
                "click",
                "DocumentationToContact",
                "資料DLから問い合わせへ"
              )
            }
          >
            <img src={ContactBtn} alt="" />
          </SonicLink>
        </div>
      </div>
    </div>
  );
};

export default DocumentationPage;
